import { useState, useEffect } from 'react';

const useMousePosition = (element: HTMLElement | null, length?: number) => {
  const [mouseXZone, setMouseXZone] = useState<number>(0);
  const [mousePosition, setMousePosition] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });

  const updateMousePosition = (event: MouseEvent) => {
    if (element) {
      if (length) {
        // decide xLocation based on how far the cursor is from the left edge of a grid item
        let rect = element.getBoundingClientRect();
        let width = rect.width;
        let x = event.clientX - rect.left;
        let xPercentage = x / width;
        let xLocation = 0;
        if (xPercentage <= 1 / length) {
          xLocation = 0;
        } else if (xPercentage > 1 / length && xPercentage < 2 / length) {
          xLocation = 1;
        } else {
          xLocation = 2;
        }
        setMouseXZone(xLocation);
      } else {
        setMousePosition({ x: event.clientX, y: event.clientY });
      }
    }
  };

  useEffect(() => {
    if (element) {
      element.addEventListener('mousemove', updateMousePosition);
      return () =>
        element.removeEventListener('mousemove', updateMousePosition);
    }
  }, [element]);

  if (length) {
    return mouseXZone;
  } else {
    return mousePosition;
  }
};

export default useMousePosition;
